import { render } from "./EmptyList.vue?vue&type=template&id=3fc1e2cc&scoped=true"
import script from "./EmptyList.vue?vue&type=script&lang=js"
export * from "./EmptyList.vue?vue&type=script&lang=js"

import "./EmptyList.vue?vue&type=style&index=0&id=3fc1e2cc&lang=scss&scoped=true"

import exportComponent from "/var/vsts_agent/_work/1505/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc1e2cc"]])

export default __exports__